import React, {useEffect, useState} from "react"
import ReactModal from 'react-modal'
import styles from "./itmodseptaboutwrap.css"
import anime from 'animejs/lib/anime.es.js';

const ITModernizationSeptAboutWrap = ( { sponsors, sponsorshipLevel }) => {

    const [learnMoreModalState,setLearnMoreModalState] = useState(false)
    const [animation, setAnimation] = useState()
    const [animationPlayed, setAnimationPlayed] = useState(false)

    const showLearnMoreModal = () => setLearnMoreModalState(true)
    const hideLearnMoreModal = () => setLearnMoreModalState(false)

    const handleScroll = () => {
        let offset = window.document.getElementById("About").getElementsByClassName("date")[0].offsetTop
        let startPoint = offset - window.scrollY
        if( startPoint <= 380 && !animationPlayed){
            // console.log('handling scroll event!')
            animation.play()
            setAnimationPlayed(!animationPlayed)
        }
    }
    useEffect( ()=>{
        // console.log('setAnimation timeline')
        /*setAnimation(anime.timeline({
            targets: ['section.about .date', 'section.about .location'],
            easing: 'cubicBezier(.5, .05, .1, .3)',
            autoplay: false
        })
        .add({
            translateX: [999, 0],
            duration: 800,
            delay: anime.stagger( 100 ),
        })
        )*/
    }, [])
    useEffect( () => {
        /*window.sponsor = sponsors
        window.sponsorshipLevel = sponsorshipLevel
        // console.log('animejs scroll eventListener added')
        window.addEventListener( 'scroll', handleScroll)
        return () => {
            // console.log('animejs scroll eventListener removed')
            window.removeEventListener( 'scroll', handleScroll)
        }*/
    })
    return (
        <section className="about" id="About">
            <div className="containfix">
                
                <div className="grid gridContain">
                    <div className="column grid1">
                        <h1>Wrap-up</h1>
                        <p className="underabout">
                        
                    <a href="https://event.on24.com/wcc/r/2628448/6B58271CCEEDA8696A8403CC6EE748F8" target="_blank" className="pinkify">Watch the On-Demand session</a> from SNG Live: IT Modernization. We had a great session with federal IT leaders who discussed progress, challenges and real-time lessons learned as they look to modernize their IT.<br /><br />
 
 We kicked off with a discussion on cloud security with Steven Hernandez, CISO of the Department of Education, and Alexis Bonnell, Senior Business Executive at Google Cloud. <br /><br />
  
 CW5 Will Robinson, the CTO & Senior Technical Advisor for the U.S. Army in the Office of the CIO, joined Jeff Frederick, Senior Solutions Engineer with Yubico Federal, for a conversation on “the future of federal identity.”<br /><br />
  
 Jacob Parcell, the Innovation Portfolio Director with the Transformation Technology Service at GSA, and Ryan Picchini, Director of Product Marketing at Acquia, shared important perspectives about online constituent services.<br /><br />
  
 Col. Bobby Saxon (Ret.), the Deputy CIO at the Centers for Medicaid & Medicare Services, and Sami Laine, Director of Technology Strategy for Okta, provided their point of view on the cultural impacts of teleworking in a post-COVID world.<br /><br />
  
 We closed out with an important conversation on virtualization with Bill Hunt, Chief Enterprise Architect at the SBA; Eddie Tejeda, Director of GSA’s Cloud.gov; and Jonathan Hardin, Senior Solutions Architect for Government, Education, Healthcare at VMware. <br /><br />

                    </p>
                        
                        <p>
                        <a className="regmobwatch" href="https://event.on24.com/wcc/r/2628448/6B58271CCEEDA8696A8403CC6EE748F8" target="_blank">WATCH NOW »</a>
                        </p>
                    </div>
                    <div class="column extra_text">
                        <a className="regworkwatch" href="https://event.on24.com/wcc/r/2628448/6B58271CCEEDA8696A8403CC6EE748F8" target="_blank">WATCH NOW »</a>
                        
                
                    </div>
                    
                    
                    <div className="column grid3">
                        <div className="grouplogos">
                            <h1>SPONSORS</h1>
                            { sponsorshipLevel ? sponsorshipLevel.map( 
                                ( level, index )  => {
                                    let levelSponsors = sponsors.filter( sponsor => sponsor.level == level && sponsor.event == "sept")
                                    let levelHasSponsors = levelSponsors.length > 0
                                    return ( 
                                        levelHasSponsors ? <div key={ index }>
                                            
                                            
                                            {levelSponsors.map( (sponsor, key ) => 
                                            <div className="logos">
                                                <a key={key}  href={sponsor.url} title={sponsor.name} target="_blank">
                                                    <img src={sponsor.logo} alt={sponsor.name} width={sponsor.width} />
                                                </a></div>)}
                                            
                                        </div>:
                                        false )
                                })
                                : <em>Missing sponsorshipLevel in gastsby-config.js</em>
                            }

                        </div>
                       
                    </div>
                </div>
                <div className="grid gridContain2">
                <div className="grid1">
                    <h3 className="wrapsub">Thought Leadership Resources</h3>
                    <p className="underabout">
                        
                         Join VMware for their annual VMworld 2020 featuring sessions for public sector customers - <a href="https://www.vmworld.com/?src=WWW_us_VMW_p2Ie0fru9EMWG1ndFJzL" target="_blank" className="pinkify">Register today for Free!</a>


                    </p>
                </div>
                </div>
            </div>
            
            <div className="sponsormob-mod" id="Sponsors">
                <div className="grouplogos">
                        <h1>SPONSORS</h1>
                        { sponsorshipLevel ? sponsorshipLevel.map( 
                                ( level, index )  => {
                                    let levelSponsors = sponsors.filter( sponsor => sponsor.level == level  && sponsor.event == "sept")
                                    let levelHasSponsors = levelSponsors.length > 0
                                    return ( 
                                        levelHasSponsors ? <div key={ index }>
                                            
                                            
                                            {levelSponsors.map( (sponsor, key ) => 
                                            <div className="logos">
                                                <a key={key}  href={sponsor.url} title={sponsor.name} target="_blank">
                                                    <img src={sponsor.logo} alt={sponsor.name} width={sponsor.width} />
                                                </a></div>)}
                                            
                                        </div>:
                                        false )
                                })
                                : <em>Missing sponsorshipLevel in gastsby-config.js</em>
                            }
                </div>
                        </div>
            <div className="sponsormob">
                <div className="containfix">
                    
                    {/*<h2 className="sponsor">BECOME A SPONSOR</h2>
                    <a className="pdf" href="https://s3.amazonaws.com/sng-global-web-assets/sponsors/SNGLIVE_SponsorPackageV2.pdf" target="_blank">DOWNLOAD PDF »</a>
                        <a className="contactus" href="mailto:sales@fedscoop.com" target="_blank">CONTACT US »</a>*/}
                </div>
            </div>
            
        </section>
    )
}

export default ITModernizationSeptAboutWrap